import React, { HTMLProps, useContext } from 'react'
import SectionWithTag from '../components/SectionWithTag'
import Image from '../components/Image'
import { twMerge } from 'tailwind-merge'
import PaddingContext from '../utils/PaddingContext'

const partners = [
    {
        id: 'thermofisher',
        className: 'w-[182px]',
    },
    {
        id: 'neogen',
        className: 'w-[182px]',
    },
    {
        id: 'kirin',
        className: 'w-[182px]',
    },
    {
        id: 'basf',
        className: 'w-[150px]',
    },
]
const Partners = ({ children }: HTMLProps<HTMLDivElement>) => {
    const { padding } = useContext(PaddingContext)

    return (
        <div className=''>
            {children}
            <div className={twMerge('py-12 md:py-30 bg-white 3xl:max-w-screen-2xl mx-auto')}>
                <SectionWithTag tag={{ id: 'section.partners.tag' }} padding={padding}>
                    <div className='grid grid-cols-2 md:grid-cols-4 items-center pt-9 md:pt-0 w-full h-full gap-y-10 gap-x-5 md:gap-6'>
                        {partners.map(({ id, className }) => (
                            <Image
                                slug={id}
                                alt={id}
                                key={id}
                                className={twMerge('justify-self-center', className)}
                            />
                        ))}
                    </div>
                </SectionWithTag>
            </div>
        </div>
    )
}

export default Partners
